import { render, staticRenderFns } from "./createOracle.vue?vue&type=template&id=93e9e046&scoped=true&"
import script from "./createOracle.vue?vue&type=script&lang=js&"
export * from "./createOracle.vue?vue&type=script&lang=js&"
import style0 from "./createOracle.vue?vue&type=style&index=0&id=93e9e046&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e9e046",
  null
  
)

export default component.exports